export default function IconNoDataFound({
  color = '#4A90E2',
  width = 136,
  height = 180,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 136 180'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M121.949 46.8011H14.0489C8.47317 46.8011 3.95312 42.281 3.95312 36.7052V13.6111C3.95312 8.03566 8.47317 3.51562 14.0489 3.51562H121.949C127.525 3.51562 132.045 8.03566 132.045 13.6114V36.7056C132.045 42.2814 127.525 46.8011 121.949 46.8011ZM121.949 90.0868H14.0489C8.47317 90.0868 3.95312 85.5668 3.95312 79.991V56.8969C3.95312 51.3211 8.47317 46.8011 14.0489 46.8011H121.949C127.525 46.8011 132.045 51.3211 132.045 56.8969V79.991C132.045 85.5668 127.525 90.0868 121.949 90.0868Z'
        fill='#4A90E2'
      />
      <path
        d='M121.96 133.276H14.0377C8.46824 133.276 3.95312 128.761 3.95312 123.192V100.171C3.95312 94.6015 8.46824 90.0864 14.0377 90.0864H121.96C127.53 90.0864 132.045 94.6015 132.045 100.171V123.192C132.045 128.761 127.53 133.276 121.96 133.276Z'
        fill='#4A90E2'
      />
      <path
        d='M67.9989 176.484C93.4725 176.484 114.123 155.834 114.123 130.36C114.123 104.887 93.4725 84.2365 67.9989 84.2365C42.5254 84.2365 21.875 104.887 21.875 130.36C21.875 155.834 42.5254 176.484 67.9989 176.484Z'
        fill='white'
      />
      <path
        d='M121.949 46.8011H14.0489M121.949 46.8011C127.525 46.8011 132.045 42.2814 132.045 36.7056V13.6114C132.045 8.03566 127.525 3.51562 121.949 3.51562H14.0489C8.47316 3.51562 3.95312 8.03566 3.95312 13.6111V36.7052C3.95312 42.281 8.47316 46.8011 14.0489 46.8011M121.949 46.8011C127.525 46.8011 132.045 51.3211 132.045 56.8969V79.991C132.045 85.5668 127.525 90.0868 121.949 90.0868M14.0489 46.8011C8.47316 46.8011 3.95312 51.3211 3.95312 56.8969V79.991C3.95312 85.5668 8.47316 90.0868 14.0489 90.0868M44.1395 90.0868H14.0489M14.0489 90.0868C8.47316 90.0868 3.95312 94.5106 3.95312 100.086V123.18C3.95312 128.756 8.47316 133.276 14.0489 133.276H20.8011M121.949 90.0868H92.6277M121.949 90.0868C127.525 90.0868 132.045 94.5106 132.045 100.086V123.18C132.045 128.756 127.525 133.276 121.949 133.276H115.197'
        stroke='#1E3A8A'
        strokeWidth='6'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.8008 68.444H67.9987M68.3848 25.1586H115.582'
        stroke='white'
        strokeWidth='6'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M67.9989 176.484C93.4725 176.484 114.123 155.834 114.123 130.36C114.123 104.887 93.4725 84.2365 67.9989 84.2365C42.5254 84.2365 21.875 104.887 21.875 130.36C21.875 155.834 42.5254 176.484 67.9989 176.484Z'
        stroke='#1E3A8A'
        strokeWidth='6'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <g clipPath='url(#clip0_4599_24091)'>
        <path
          d='M53.4165 148.274C52.534 148.326 51.6659 148.032 50.9955 147.456C49.6734 146.126 49.6734 143.978 50.9955 142.648L79.9459 113.698C81.321 112.411 83.4788 112.482 84.7656 113.857C85.9292 115.101 85.997 117.012 84.9244 118.335L55.8034 147.456C55.1417 148.024 54.2875 148.317 53.4165 148.274Z'
          fill='#F07268'
        />
        <path
          d='M82.3329 148.274C81.4383 148.271 80.5811 147.916 79.9459 147.286L50.9954 118.335C49.7705 116.905 49.937 114.752 51.3674 113.527C52.6441 112.434 54.5269 112.434 55.8034 113.527L84.9244 142.477C86.2992 143.765 86.3703 145.923 85.0832 147.297C85.032 147.352 84.9791 147.405 84.9244 147.456C84.5716 147.763 84.1595 147.994 83.7137 148.135C83.2679 148.275 82.7979 148.323 82.3329 148.274Z'
          fill='#F07268'
        />
      </g>
      <defs>
        <clipPath id='clip0_4599_24091'>
          <rect width='36' height='36' fill='white' transform='translate(50 112.5)' />
        </clipPath>
      </defs>
    </svg>
  );
}
